import * as React from 'react';
import { translate } from 'react-i18next';
import * as c from 'models/constants';
import { IItemCardProps } from 'models/itemcard';
import { formatCurrency, setProductPictureUrl, formatInteger } from 'helpers/common';
import { IOrderItem } from 'models/orders/order';
require('./style.css');

interface IProps extends IItemCardProps {
	item: IOrderItem;
	t?: (key: string, options?: any) => string;
	currencyKey?: number;
}

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class OrderCardItemCard extends React.Component<IProps, any> {
	constructor(props) {
		super(props);

		this.goToCard = this.goToCard.bind(this);
	}

	private goToCard(e: any, id: string, target: string) {
		e.preventDefault();
		if (this.props.goToCard) {
			this.props.goToCard(id, c.NODE_TYPE_PRODUCT, target);
		}
	}

	public render() {
		const { t, currencyKey } = this.props;
		const { productPicture, productName, qty, price, productId, productSKU } = this.props.item;
		const qtyText = `${t('BSPortal_Common_Qty')}: ${formatInteger(qty)}`;
		const skuText = `${t('Shop_ManageShop_Products_CreateProduct_Label_SKU')}: ${productSKU}`;

		return (
			<div className="col-md-12 orderCardItemCard">
				<div className="row">
					<div className="col-xs-5 col-md-2 wrapperImage">
						<a
							href="#"
							onClick={(e) => {
								this.goToCard(e, productId, '_blank');
							}}
							className="imageHolder"
						>
							<img {...setProductPictureUrl(productPicture)} />
						</a>
					</div>
					<div className="col-xs-7 col-md-10 wrapperName">
						<div>
							<a
								href="#"
								onClick={(e) => {
									this.goToCard(e, productId, '_blank');
								}}
							>
								<div className="name">{productName}</div>
							</a>
						</div>
						<div>
							<a
								href="#"
								onClick={(e) => {
									this.goToCard(e, productId, '_blank');
								}}
							>
								<div className="sizeColor">{skuText}</div>
							</a>
						</div>
						<div className="sizeColor">{qtyText}</div>
						<div className="wrapperPrice">
							<span className="amount">{formatCurrency(currencyKey, price)}</span>
						</div>
					</div>
				</div>
			</div>
		);
	}
}
export { OrderCardItemCard };
